import { styled, Typography } from '@mui/material'

const FinancialAmount = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'amountType',
})<{ amountType?: 'positive' | 'neutral' | 'negative' }>(
  ({ theme, amountType = 'positive' }) => {
    const colors = {
      positive: theme.palette.primary.main,
      neutral: theme.palette.primary.main,
      negative: theme.palette.textOrIcon.redButton,
    }

    return {
      color: colors[amountType],
      fontFamily: 'sweet-sans-pro, sans-serif',
      fontWeight: 700,
      fontSize: '0.875rem',
      textAlign: 'right',
    }
  }
)

export default FinancialAmount
